<template>
  <div class="keeper-roi-view">
    <KeeperROI />
  </div>
</template>

<script>
import KeeperROI from "../components/KeeperROI.vue";

export default {
  name: "KeeperROIView",
  components: {
    KeeperROI,
  },
};
</script>

<style scoped>
.keeper-roi-view {
  min-height: 100vh;
  background-color: #1e1e1e;
}
</style>
